import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useUnseenEngagementCount(userId: string | undefined) {
  return useQuery({
    queryKey: ["unseen-engagement-count", userId],
    queryFn: async (): Promise<number> => {
      if (!userId) return 0;
      
      const { data, error } = await supabase.rpc("get_unseen_engagement_count", {
        _user_id: userId,
      });
      
      if (error) throw error;
      return Number(data) || 0;
    },
    enabled: !!userId,
    staleTime: 1000 * 60, // 1 minute
    refetchInterval: 1000 * 60, // Refetch every minute
  });
}

export function useMarkEngagementSeen() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (userId: string) => {
      const { error } = await supabase.rpc("mark_engagement_seen", {
        _user_id: userId,
      });
      
      if (error) throw error;
    },
    onSuccess: (_, userId) => {
      // Invalidate the count query to update sidebar immediately
      queryClient.invalidateQueries({ queryKey: ["unseen-engagement-count", userId] });
    },
  });
}
